var Acr = Acr || {};

/**
  * @desc Checks for Pre Hidden elements and sets the functionality to show the hidden component
*/
Acr.ShowPreHiddenComponents = (showRightNow = true) => {
  const preHiddenElements = document.querySelectorAll('[pre-hidden]');

  preHiddenElements.forEach((preHiddenElement) => {
    const duration = preHiddenElement.getAttribute('pre-hidden') || 3000;
    if (showRightNow) {
      preHiddenElement.removeAttribute('pre-hidden');
    } else {
      setTimeout(() => {
        preHiddenElement.removeAttribute('pre-hidden');
      }, duration);
    }
  });   
};

Acr.ShowPreHiddenComponents(false);
